
import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { Bet } from '../../types.ts';

interface ProfitChartProps {
  bets: Bet[];
}

const ProfitChart: React.FC<ProfitChartProps> = ({ bets }) => {
  if (!bets || bets.length === 0) return null;

  const sortedBets = [...bets].sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

  let cumulative = 0;
  const data = sortedBets.map(b => {
    cumulative += b.profit || 0;
    return {
      date: b.date,
      profit: parseFloat(cumulative.toFixed(2))
    };
  });

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data}>
        <defs>
          <linearGradient id="colorProfit" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#00ff66" stopOpacity={0.3} />
            <stop offset="95%" stopColor="#00ff66" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#2b3139" vertical={false} />
        <XAxis
          dataKey="date"
          stroke="#b1b5c0"
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={(val) => new Date(val).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}
        />
        <YAxis
          stroke="#b1b5c0"
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={(val) => `$${val}`}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#1e2329',
            border: '1px solid #474d57',
            borderRadius: '12px',
            color: '#eaecef'
          }}
          itemStyle={{ color: '#00ff66', fontWeight: 'bold' }}
          labelStyle={{ color: '#b1b5c0', marginBottom: '4px' }}
          formatter={(value: any) => [`$${value}`, 'Lucro Acumulado']}
        />
        <Area
          type="monotone"
          dataKey="profit"
          stroke="#00ff66"
          strokeWidth={3}
          fillOpacity={1}
          fill="url(#colorProfit)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default ProfitChart;
